import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ROUTES } from "./routes";
import BaseLayout from "../components/_ui/layout/base_layout";
import { observer, Provider } from "mobx-react";
import store from "../_services/store";
import { useEffect } from "react";
import {
  ArticlePage,
  BibliographyPage,
  ExpertsPage,
  HomePage,
  InformationsPage,
  MoleculeDetail,
  MoleculesPage,
  NewsPage,
  SymptomDetail,
  SymptomsPage,
  TrainingPage,
  QuizzSelection,
  Quizz,
  ProfilePage,
  LegalNotice,
} from "../components/pages";
import Auth from "../components/pages/user/auth";
import { PageNotFound } from "../components/_ui";
import Registerpage from "../components/pages/register/register"

const PublicRoutes = () => (
  <BaseLayout>
    <Routes>
      <Route path={ROUTES.AUTH()} element={<Auth authorize={true} />} />
      <Route path={ROUTES.REGISTER()} Component={Registerpage} />
      <Route path={ROUTES.ANY()} Component={Auth} />
    </Routes>
  </BaseLayout>
)

const LoggedRoutes = () => (
  <BaseLayout>
    <Routes>
      <Route path={ROUTES.HOME()} Component={HomePage} />
      <Route path={ROUTES.MOLECULES()} Component={MoleculesPage} />
      <Route path={ROUTES.MOLECULE_DETAIL(':id')} Component={MoleculeDetail} />
      <Route path={ROUTES.SYMPTOMS()} Component={SymptomsPage} />
      <Route path={ROUTES.SYMPTOM_DETAIL(':id')} Component={SymptomDetail} />
      <Route path={ROUTES.TRAINING()} Component={TrainingPage} />
      <Route path={ROUTES.QUIZZES()} Component={QuizzSelection} />
      <Route path={ROUTES.QUIZZ()} Component={Quizz} />
      <Route path={ROUTES.INFORMATIONS()} Component={InformationsPage} />
      <Route path={ROUTES.LEGAL_NOTICE()} Component={LegalNotice} />
      <Route path={ROUTES.ARTICLE(':id')} Component={ArticlePage} />
      <Route path={ROUTES.NEWS()} Component={NewsPage} />
      <Route path={ROUTES.EXPERTS()} Component={ExpertsPage} />
      <Route path={ROUTES.BIBLIOGRAPHY()} Component={BibliographyPage} />
      <Route path={ROUTES.PROFILE()} Component={ProfilePage} />
      <Route path={ROUTES.ANY()} Component={PageNotFound} />
    </Routes>
  </BaseLayout>
)

const ApplicationRoutes = observer(() => {  
  return store.authToken ? <LoggedRoutes /> : <PublicRoutes />;
});

const AppRouter = () => {
  return (
    <Provider store={store}>
      <BrowserRouter basename="/">
        <ApplicationRoutes />
      </BrowserRouter>
    </Provider>
  );
};

export default AppRouter;